import React from "react";
import { Create, minValue, Notification, NumberInput, SimpleForm, TextInput } from "react-admin";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { validateRequired } from "../../../utils/Validations";
import CreateToolbar from "../../Custom/create-save-button";
import { CustomBooleanInput } from "../../Signet/util";
import AppMultiSelect from "../../AppMultiSelect/AppMultiSelect";
import { CustomSelect } from "../../CustomPricing/util";

const useStyles = makeStyles({
    container: {
        width: "100%",
    },
});

// Custom validation function for positive numbers
const validatePositiveNumber = (value) => {
    if (value !== undefined && value !== null && value <= 0) {
        return 'Value must be greater than 0';
    }
    return undefined;
};

const CollegiateEngravingCreate  = (props) => {
    const classes = useStyles();

   return (
        <ThemeProvider>
            <Create {...props} className="overflow-visible">
                <SimpleForm toolbar={<CreateToolbar />}>
                    <Grid container justify="space-between" className={classes.container}>
                        <Grid item xs={5}>
                            <TextInput source="name" fullWidth validate={validateRequired}/>
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput source="sku_code"  fullWidth validate={validateRequired}/>
                        </Grid>
                        <Grid item xs={5}>
                            <CustomBooleanInput source="allow_cerakote" label="Allow Cerakote" fullWidth/>
                            <CustomBooleanInput source="enabled" label="Enabled" fullWidth/>
                            <CustomBooleanInput source="allow_on_primary_ring" label="Allow on Primary Ring" fullWidth/>
                            <CustomBooleanInput source="allow_on_inlay" label="Allow on Inlay" fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <CustomBooleanInput source="allow_inside_engraving" label="Allow Inside Engraving" fullWidth/>
                            <CustomBooleanInput source="allow_inside_cerakote" label="Allow Inside Cerakote" fullWidth/>
                            <CustomBooleanInput source="has_inside_reversed_option" label="Has Inside Reversed Option" fullWidth/>
                            <CustomBooleanInput source="has_outside_reversed_option" label="Has Outside Reversed Option" fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <NumberInput source="markup" min={0} validate={[validateRequired, minValue(0)]} fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <NumberInput source="inside_minimum_width" min={0} validate={[validateRequired, minValue(0)]} label="Inside Minimum Width" fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <NumberInput source="outside_minimum_width" min={0} validate={[validateRequired, minValue(0)]} label="Outside Minimum Width" fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <NumberInput source="outside_live_tool_laser" min={0} validate={[validateRequired, minValue(0)]} label="Outside Live Tool Laser" fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <NumberInput source="inside_live_tool_laser" min={0} validate={[validateRequired, minValue(0)]} label="Inside Live Tool Laser" fullWidth/>
                        </Grid>
                        <Grid item xs={5}>
                            <CustomSelect
                                source="machine_pattern_type_id"
                                label="Machine Pattern Type"
                                resource={"custom-pricing/machine-pattern-types"}
                                fullWidth
                                optionValue="id"
                                validate={validateRequired}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <CustomSelect
                                source="school"
                                label="School"
                                resource={"schools"}
                                fullWidth
                                optionValue="id"
                                defaultValue={1}
                                validate={validateRequired}
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <AppMultiSelect
                                reference={"custom-pricing/profiles"}
                                label="Profiles Allowed"
                                source="profiles_allowed"
                                optionValue="id"
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <AppMultiSelect
                                reference={"custom-pricing/ring-materials"}
                                label="Ring Materials Allowed"
                                source="ring_materials_allowed"
                                optionValue="id"
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <AppMultiSelect
                                reference={"custom-pricing/inlays"}
                                label="Inlays Allowed"
                                source="inlays_allowed"
                                optionValue="id"
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <AppMultiSelect
                                reference="custom-pricing/sleeves"
                                label="Sleeves Allowed"
                                source="sleeves_allowed"
                                optionValue="id"
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <AppMultiSelect
                                reference={"school-cerakote-colors"}
                                label="Cerakote Colors Allowed"
                                source="cerakote_colors_allowed"
                                optionValue="id"
                            />
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Create>
            <Notification />
        </ThemeProvider>
    );
};

export default CollegiateEngravingCreate;
